function hexToRgb(hex: string): [number, number, number] | null {
  const m = /^#([0-9a-f]{6})$/i.exec(hex.trim())
  if (!m) return null
  const n = parseInt(m[1], 16)
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255]
}

function rgbToHsl(r: number, g: number, b: number): [number, number, number] {
  const r1 = r / 255, g1 = g / 255, b1 = b / 255
  const max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1)
  const l = (max + min) / 2
  if (max === min) return [0, 0, l]
  const d = max - min
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
  let h: number
  switch (max) {
    case r1: h = ((g1 - b1) / d + (g1 < b1 ? 6 : 0)) / 6; break
    case g1: h = ((b1 - r1) / d + 2) / 6; break
    default:  h = ((r1 - g1) / d + 4) / 6
  }
  return [h * 360, s, l]
}

function hslToRgb(h: number, s: number, l: number): [number, number, number] {
  const a = s * Math.min(l, 1 - l)
  const f = (n: number) => {
    const k = (n + h / 30) % 12
    return Math.round((l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))) * 255)
  }
  return [f(0), f(8), f(4)]
}

const DEFAULT_SHADES: Record<number, string> = {
  300: '147 197 253',
  400: '96 165 250',
  500: '59 130 246',
  600: '37 99 235',
  700: '29 78 216',
  900: '30 58 138',
}

export function applyBrandColor(hex: string) {
  const rgb = hexToRgb(hex)
  const root = document.documentElement
  if (!rgb) {
    for (const [shade, val] of Object.entries(DEFAULT_SHADES))
      root.style.setProperty(`--brand-${shade}`, val)
    try { localStorage.removeItem('edrikom_theme') } catch {}
    return
  }
  const [h, s] = rgbToHsl(...rgb)
  const shades: Record<number, [number, number, number]> = {
    300: hslToRgb(h, Math.min(s * 0.85, 1), 0.76),
    400: hslToRgb(h, Math.min(s * 0.92, 1), 0.64),
    500: hslToRgb(h, Math.min(s,       1), 0.52),
    600: hslToRgb(h, Math.min(s * 1.05, 1), 0.44),
    700: hslToRgb(h, Math.min(s * 1.08, 1), 0.36),
    900: hslToRgb(h, Math.min(s * 0.9,  1), 0.22),
  }
  const cache: Record<string, string> = {}
  for (const [shade, [r, g, b]] of Object.entries(shades)) {
    const val = `${r} ${g} ${b}`
    root.style.setProperty(`--brand-${shade}`, val)
    cache[`--brand-${shade}`] = val
  }
  try { localStorage.setItem('edrikom_theme', JSON.stringify(cache)) } catch {}
}
